import { loading } from '@/common/loading';
import { getFillList, getUserInfoAjax2 } from '@/api/baseMsg';

export default {
  name: 'questionnaireFilling',
  data() {
    return {
      option: [],
      List: [],
      searchName: '',
      userId: ''
    };
  },
  created() {
    this.init();
  },
  mounted() {
    window.addEventListener('scroll', this.scrollToTop);
  },
  destroyed() {
    window.removeEventListener('scroll', this.scrollToTop);
  },
  methods: {
    init() {
      loading(true);
      this.getUserInfoAjax();
    },
    getUserInfoAjax() {
      getUserInfoAjax2().then((res) => {
        if (res.code == 200) {
          this.userId = res.data.id;
          this.handQuery();
        }
      });
    },
    handQuery() {
      const params = {
        title: this.searchName ? this.searchName : '',
        userId: this.userId
      };
      getFillList(params).then((res) => {
        this.List = res.list;
        loading(false);
      });
    },
    handck(item) {
      this.$router.push('/Fill' + `?state=2&QuestionnaireID=${item.QuestionnaireID}&regionCode=${item.regionCode}&userId=${item.userId}&isFill=${item.isFill}` );
    },
    handFill(item) {
      this.$router.push('/Fill' + `?QuestionnaireID=${item.QuestionnaireID}&regionCode=${item.regionCode}&userId=${item.userId}&isFill=${item.isFill}` );
    },
    onClickLeft() {
      this.$router.push('/');
    }
  }
};
